import * as helpers from '../helpers';
import * as SearchActions from '../actions/SearchActions';
import iconXBlack from '../img/icon-x-black.png';
import ListFilter from './ListFilter';
import Pagination from './Pagination';
import PropTypes from 'prop-types';
import QueryString from 'query-string';
import React from 'react';
import SearchItem from './SearchItem';
import SearchClearOrBusy, {SEARCH_BUSY_MIN_MS} from './SearchClearOrBusy';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


const ITEMS_PER_PAGE = 10;
const filterTypes = [
  {id: 'project', title: 'Project'},
  {id: 'news', title: 'News'},
  {id: 'event', title: 'Event'},
  {id: 'document', title: 'Document'},
  {id: 'program', title: 'Program'},
  {id: 'map', title: 'Map'},
  {id: 'other', title: 'Other'},
];


class SearchDraftForm extends React.Component{
  state = {
    hasText: Boolean(this.props.query),
  };

  constructor(props){
    super(props);
    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps){
    if(prevProps.query !== this.props.query && this.inputRef.current){
      const next = this.props.query || '';
      this.inputRef.current.value = next;
      this.syncHasText(next);
    }
  }

  syncHasText = value => {
    const hasText = Boolean(value && String(value).length > 0);
    if(hasText !== this.state.hasText){
      this.setState({hasText});
    }
  };
  handleChange = evt => {
    this.syncHasText(evt.target.value);
  };
  handleSubmit = evt => {
    evt.preventDefault();
    const value = ((this.inputRef.current && this.inputRef.current.value) || '').trim();
    this.props.onSubmit(value);
  };
  handleClear = () => {
    if(this.inputRef.current){
      this.inputRef.current.value = '';
    }
    this.syncHasText('');
    this.props.onClear();
  };

  render(){
    const {hasText} = this.state;
    const {searchBusy, query} = this.props;
    const isOpen = hasText || searchBusy;

    return (
      <form className={`button-input ${isOpen ? 'search-input-open' : ''}`}
            role="search"
            onSubmit={this.handleSubmit}>
        <input aria-label="Search Input"
               className={`button-input__input input ${isOpen ? 'search-input-open' : ''}`}
               type="text"
               name="query"
               defaultValue={query || ''}
               placeholder="Search"
               aria-busy={searchBusy ? true : undefined}
               onChange={this.handleChange}
               ref={this.inputRef}/>

        {isOpen && <SearchClearOrBusy isLoading={searchBusy}
                                     iconSrc={iconXBlack}
                                     onClear={this.handleClear}/>}
      </form>
    );
  }
}


class Search extends React.Component{
  state = {
    currentPage: 1,
    appliedQuery: '',
    selectedProgram: [],
    selectedType: filterTypes.map(item => item.id),
    modalOpen: false,
    searchBusy: false,
  };


  constructor(props){
    super(props);

    this.handleClearInput = this.handleClearInput.bind(this);
  }
  componentDidMount(){
    this.props.actions.loadProgramFilterOptions().then(options => {
      if(options && options.length){
        this.setState({
          selectedProgram: options.map(item => item.id),
        });
      }
    });
    this.fetchContent();
  }
  componentWillUnmount(){
    window.clearTimeout(this._searchBusyTimer);
  }
  componentDidUpdate(prevProps){
    if(prevProps.location.search !== this.props.location.search){
      this.fetchContent();
    }
  }


  finishSearchBusy = (startedAt) => {
    const wait = Math.max(0, SEARCH_BUSY_MIN_MS - (Date.now() - startedAt));
    window.clearTimeout(this._searchBusyTimer);
    this._searchBusyTimer = window.setTimeout(() => {
      this.setState({searchBusy: false});
    }, wait);
  };
  runSearch = (q) => {
    if(!q){
      window.clearTimeout(this._searchBusyTimer);
      this.setState({searchBusy: false});
      return Promise.resolve(this.props.actions.initSearch(''));
    }
    const startedAt = Date.now();
    return Promise.resolve(this.props.actions.initSearch(q))
      .then(() => this.finishSearchBusy(startedAt))
      .catch(() => this.setState({searchBusy: false}));
  };
  fetchContent(){
    const query = QueryString.parse(this.props.location.search);
    const q = query.q || '';
    this.setState({
      appliedQuery: q,
      currentPage: 1,
      searchBusy: Boolean(q),
    });
    this.runSearch(q);
  }


  getAllTypeIds = () => filterTypes.map(item => item.id);
  getAllProgramIds = () => (this.props.searchResult.programOptions || []).map(item => item.id);
  applyTypeFilter = selectedType => {
    const allTypeIds = this.getAllTypeIds();
    const filterActive = selectedType.length > 0 && selectedType.length < allTypeIds.length;
    this.props.actions.setTypes(filterActive ? selectedType : []);
  };
  applyProgramFilter = selectedProgram => {
    const allProgramIds = this.getAllProgramIds();
    const filterActive = selectedProgram.length > 0 && selectedProgram.length < allProgramIds.length;
    this.props.actions.setProgram(filterActive ? selectedProgram : []);
  };
  handleCategoryFilter = (value, type) => {
    if(type === 'type'){
      const selectedType = this.state.selectedType.includes(value)
        ? this.state.selectedType.filter(id => id !== value)
        : [...this.state.selectedType, value];
      this.setState({selectedType});
      this.applyTypeFilter(selectedType);
    }
    else if(type === 'program'){
      const selectedProgram = this.state.selectedProgram.includes(value)
        ? this.state.selectedProgram.filter(id => id !== value)
        : [...this.state.selectedProgram, value];
      this.setState({selectedProgram});
      this.applyProgramFilter(selectedProgram);
    }
  };
  handleClearFilter = () => {
    const selectedType = this.getAllTypeIds();
    const selectedProgram = this.getAllProgramIds();
    this.setState({
      selectedType,
      selectedProgram,
    });
    this.applyTypeFilter(selectedType);
    this.applyProgramFilter(selectedProgram);
  };
  handleClearInput = () => {
    window.clearTimeout(this._searchBusyTimer);
    this.setState({
      appliedQuery: '',
      currentPage: 1,
      searchBusy: false,
    });

    if(this.props.location.search){
      this.props.history.push({pathname: '/search', search: ''});
      return;
    }
    this.runSearch('');
  };
  handleSubmit = value => {
    const nextSearch = value ? `?q=${encodeURIComponent(value)}` : '';
    const currentSearch = this.props.location.search || '';
    const urlUnchanged = currentSearch === nextSearch
      || (!value && !currentSearch.replace(/^\?/, ''));

    this.setState({
      appliedQuery: value,
      currentPage: 1,
      searchBusy: Boolean(value),
    }, () => {
      window.setTimeout(() => {
        if(urlUnchanged){
          this.runSearch(value);
          return;
        }
        this.props.history.push({
          pathname: '/search',
          search: nextSearch,
        });
      }, 0);
    });
  };
  handleModalHide = () => {
    this.setState({
      modalOpen: false,
    });
  };
  handleModalShow = () => {
    this.setState({
      modalOpen: true,
    });
  };
  handlePagination = page => {
    this.setState({
      currentPage: page,
    });
  };


  renderItems = () => {
    const {currentPage} = this.state;
    const {searchResult} = this.props;
    const {
      total,
      newsResult,
      eventResult,
      programResult,
      projectResult,
      pageContentDetailResult,
    } = searchResult;

    if(total === 0) return null;

    const newResult = newsResult
      .concat(eventResult)
      .concat(programResult)
      .concat(projectResult)
      .concat(pageContentDetailResult || []);

    return newResult
      .slice((currentPage - 1) * ITEMS_PER_PAGE, ITEMS_PER_PAGE * currentPage)
      .map((item, index) => {
        return (
          <div key={item.id} className="col-12">
            <SearchItem title={helpers.getHighlightedText(item.title, this.state.appliedQuery)}
                        url={item.slug || ''}
                        type={item.type}
                        className={index === ITEMS_PER_PAGE - 1 ? 'remove--border' : ''}/>
          </div>
        );
      });
  };
  renderResultStatus = () => {
    const {searchResult} = this.props;
    const {total, filterQuery} = searchResult;
    const {currentPage} = this.state;
    const startFrom = (currentPage - 1) * ITEMS_PER_PAGE + 1;
    const lastTo = currentPage * ITEMS_PER_PAGE > total ? total : currentPage * ITEMS_PER_PAGE;

    return (
      <div className="search__results">
        {`Results ${startFrom}-${lastTo} of ${total}`}
        {filterQuery !== '' && (
          <span>
            {' '}
            for <span style={{fontWeight: 600}}>{filterQuery}</span>
          </span>
        )}
      </div>
    );
  };
  render(){
    //console.log(`MEvents render`, this.props);


    const {appliedQuery, selectedType, selectedProgram, modalOpen, searchBusy} = this.state;
    const {searchResult} = this.props;
    const totalPage = searchResult.total / ITEMS_PER_PAGE;

    return (
      <div className="columns">
        <div className="coupling coupling--parent coupling--left">
          <div className={`search-page ${this.props.className || ''}`}>
            <div className="container container--coupling">
              <SearchDraftForm query={appliedQuery}
                               searchBusy={searchBusy}
                               onSubmit={this.handleSubmit}
                               onClear={this.handleClearInput}/>
              {Boolean(appliedQuery) && searchResult.total !== 0 && this.renderResultStatus()}
              {Boolean(appliedQuery) && !searchBusy && searchResult.total === 0 && (
                <div className="no-search-results">
                  <div>
                    {`Sorry this search doesn't have any results.`}
                  </div>
                  <div className="no-results-suggestion">
                    Search Suggestions
                    <ul>
                      <li>Check spelling</li>
                      <li>Try more general words</li>
                      <li>Remove some search filters</li>
                      <li>
                        <a href="/get-involved" target="_blank">Contact us</a> {`if you still can't find what you are looking for`}
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="news__listing">
                <div className="row">{this.renderItems()}</div>
              </div>
              {searchResult.total > 0 && (
                <Pagination totalPage={totalPage}
                            currentPage={this.state.currentPage}
                            handlePagination={this.handlePagination}/>
              )}
            </div>
          </div>
        </div>
        <div className="coupling coupling--parent coupling--right">
          <ListFilter programs={searchResult.programOptions || []}
                      types={filterTypes}
                      selectedProgram={selectedProgram}
                      selectedType={selectedType}
                      title="Filter Results"
                      handleCategoryFilter={this.handleCategoryFilter}
                      disableDate={true}
                      handleClearFilter={this.handleClearFilter}
                      modalOpen={modalOpen}
                      handleModalHide={this.handleModalHide}/>
        </div>
      </div>
    );
  }
}


export default withRouter(connect(
  state => ({
    searchResult: state.searchResult,
  }),
  dispatch => ({
    actions: bindActionCreators(SearchActions, dispatch),
  }),
)(Search));


Search.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object,
  searchResult: PropTypes.object,
};
